export default __webpack_public_path__ + "static/burna-938737e1aafafa0a4a834a74646910c1.png";